import PropTypes from 'prop-types';
import TreeItem from '../Components/TreeNavigator/TreeItem';

const TreeNavigatorItemPropTypes = {
  treeItem: PropTypes.instanceOf(TreeItem).isRequired,
};

export default TreeNavigatorItemPropTypes;
